import React from 'react';
import { useDashboard } from '../context/DashboardContext';
import { getCategorySpending, formatCurrency } from '../utils/helpers';

function Insights() {
  const { transactions } = useDashboard();
  const spending = getCategorySpending(transactions);

  const now = new Date();
  const curM  = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const prevM = `${now.getFullYear()}-${String(now.getMonth()).padStart(2, '0')}`;

  const curExp  = transactions.filter((t) => t.date.startsWith(curM)  && t.type === 'expense').reduce((s, t) => s + t.amount, 0);
  const prevExp = transactions.filter((t) => t.date.startsWith(prevM) && t.type === 'expense').reduce((s, t) => s + t.amount, 0);
  const change  = prevExp > 0 ? ((curExp - prevExp) / prevExp) * 100 : 0;
  const avg     = transactions.length > 0 ? transactions.reduce((s, t) => s + t.amount, 0) / transactions.length : 0;
  const top     = spending[0];

  const insights = [
    {
      icon: '📊',
      title: 'Highest Spending',
      desc: top ? `${top.category} is your top expense at ${formatCurrency(top.amount)}` : 'No expense data yet',
      mod: 'orange',
    },
    {
      icon: '📅',
      title: 'Monthly Comparison',
      desc:
        change > 0  ? `Spending increased by ${Math.abs(change).toFixed(1)}% this month`  :
        change < 0  ? `Spending decreased by ${Math.abs(change).toFixed(1)}% this month`  :
                      'Spending is consistent with last month',
      mod: change > 0 ? 'red' : 'green',
    },
    {
      icon: '🎯',
      title: 'Average Transaction',
      desc: `Your average transaction value is ${formatCurrency(avg)}`,
      mod: 'blue',
    },
    {
      icon: '💡',
      title: 'Budget Insight',
      desc: curExp > 5000 ? 'Consider reviewing your spending patterns' : "You're managing your budget well",
      mod: curExp > 5000 ? 'red' : 'green',
    },
  ];

  return (
    <div className="card">
      <h3 className="card__title">Financial Insights</h3>
      <div className="insights-grid">
        {insights.map((ins, i) => (
          <div key={i} className={`insight-item insight-item--${ins.mod}`}>
            <div className="insight-item__icon">{ins.icon}</div>
            <div>
              <p className="insight-item__title">{ins.title}</p>
              <p className="insight-item__desc">{ins.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Insights;
